module.exports = __webpack_public_path__ + "img/weixings.df57960b.png";